/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Email_PlaceholderInputs */

const en_user_profile_email_placeholder = /** @type {(inputs: User_Profile_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter user email`)
};

const de_user_profile_email_placeholder = /** @type {(inputs: User_Profile_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse des Benutzers eingeben`)
};

/**
* | output |
* | --- |
* | "Enter user email" |
*
* @param {User_Profile_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const user_profile_email_placeholder = /** @type {((inputs?: User_Profile_Email_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Email_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_user_profile_email_placeholder(inputs)
	return en_user_profile_email_placeholder(inputs)
});